import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author:
 *
 *Description:
 */
import React from 'react';
import DOMPurify from 'dompurify';
import { values as _values } from 'lodash-es';
import navigation from '../../../lib/navigation/navigation';
import FootnoteModalContent from '../renderers/footnote-modal/FootnoteModalContent';
import { renderCmsComponent, reactAttr, getStylesFromNode } from './index';
import SectionLink from '../utils/section-link/SectionLink';
import Markup from '../../markup/Markup';
import styles from './utils.less';

var ComponentByNode = /*#__PURE__*/function () {
  function ComponentByNode(_domNode, _children) {
    var _this = this;

    _classCallCheck(this, ComponentByNode);

    _defineProperty(this, "getNodeAttributes", function () {
      var domNode = _this.domNode;

      var collection = _objectSpread({}, domNode.attributes);

      return _values(collection).reduce(function (nodeAttributes, attrNode) {
        // ie bug
        if (!attrNode) {
          return nodeAttributes;
        }

        var attrName = attrNode.name;
        var attrValue = domNode.getAttribute(attrName);

        if (attrName === 'style') {
          nodeAttributes.style = getStylesFromNode(domNode.style);
          return nodeAttributes;
        }

        var attrKey = reactAttr[attrName] || attrName;
        nodeAttributes[attrKey] = attrValue;
        return nodeAttributes;
      }, {});
    });

    _defineProperty(this, "getFootnoteDetails", function (footnotes) {
      //eslint-disable-line
      var domNode = _this.domNode;

      for (var i = 0; i < footnotes.length; i++) {
        var component = footnotes[i] && footnotes[i].component;

        if (component && (domNode && domNode.dataset && domNode.dataset.footnote) === component.id) {
          var footnoteTitle = domNode.innerHTML || '';
          return {
            footnoteNumber: i + 1,
            footnoteTitle: footnoteTitle,
            footnoteText: component.content && component.content.text || ''
          };
        }
      }
    });

    _defineProperty(this, "getFootnote", function (_ref) {
      var footnotes = _ref.footnotes,
          templateType = _ref.templateType;

      var footnoteDetails = footnotes && _this.getFootnoteDetails(footnotes);

      return footnoteDetails ? function () {
        return /*#__PURE__*/React.createElement("sup", {
          "data-cms-footnote-id": "cms_footnote_".concat(_this.domNode.dataset.footnote)
        }, /*#__PURE__*/React.createElement(FootnoteModalContent, _extends({
          templateType: templateType
        }, footnoteDetails)));
      } : null;
    });

    _defineProperty(this, "handleRouteNavigation", function (_ref2) {
      var event = _ref2.event,
          openModal = _ref2.openModal,
          dataLinkType = _ref2.dataLinkType,
          mojoJumpPage = _ref2.mojoJumpPage,
          navigationUrl = _ref2.navigationUrl,
          dataDisplayType = _ref2.dataDisplayType,
          setModalNavigationDetails = _ref2.setModalNavigationDetails;
      event.preventDefault();
      event.stopPropagation();

      if (mojoJumpPage) {
        setModalNavigationDetails({
          navigationUrl: navigationUrl,
          openMojoJumpPage: true
        });
      } else if (dataLinkType === 'external') {
        setModalNavigationDetails({
          navigationUrl: navigationUrl,
          dataDisplayType: dataDisplayType,
          dataLinkType: dataLinkType
        });
        openModal();
      } else {
        navigation({
          navigationUrl: navigationUrl,
          displayType: dataDisplayType,
          samlDetails: {
            browserMode: dataLinkType
          }
        });
      }
    });

    _defineProperty(this, "getLink", function (_ref3) {
      var openModal = _ref3.openModal,
          setModalNavigationDetails = _ref3.setModalNavigationDetails,
          getString = _ref3.getString,
          references = _ref3.references;
      var domNode = _this.domNode,
          handleRouteNavigation = _this.handleRouteNavigation,
          children = _this.children;

      if (!domNode || domNode.className === 'phoneNumber') {
        return null;
      }

      if (domNode.getAttribute('data-link-type') === 'section-link') {
        return function () {
          return /*#__PURE__*/React.createElement(SectionLink, {
            targetId: (domNode.getAttribute('href') || '').replace('#', '')
          }, /*#__PURE__*/React.createElement(Markup, {
            content: domNode.innerHTML
          }));
        };
      }

      var dataReferenceID = domNode.getAttribute('data-reference-id');

      if (dataReferenceID) {
        return references ? function () {
          return renderCmsComponent(references[dataReferenceID], dataReferenceID);
        } : null;
      }

      var navigationUrl = domNode.getAttribute('data-url');
      domNode.setAttribute('tabindex', 0);
      domNode.setAttribute('role', 'link');
      var alternateDisplayType = domNode.getAttribute('class');

      if (alternateDisplayType) {
        alternateDisplayType = alternateDisplayType.includes('saml') ? 'saml' : null;
      }

      var dataDisplayType = domNode.getAttribute('data-display-type') || alternateDisplayType || 'saml';
      var dataConfirmRequired = domNode.getAttribute('data-confirm-required');
      var alternateLinkType = dataConfirmRequired === 'confirm-dispatch' ? 'external' : null;
      var dataLinkType = domNode.getAttribute('data-link-type') || alternateLinkType;
      var mojoJumpPage = domNode.getAttribute('data-mojo-content');
      if (dataLinkType === 'external') domNode.setAttribute('aria-label', 'Opens Dialog');

      var routeNavigation = function routeNavigation(event) {
        return handleRouteNavigation({
          event: event,
          dataLinkType: dataLinkType,
          dataDisplayType: dataDisplayType,
          mojoJumpPage: mojoJumpPage,
          navigationUrl: navigationUrl,
          openModal: openModal,
          setModalNavigationDetails: setModalNavigationDetails
        });
      };

      var handleKeyDown = function handleKeyDown(event) {
        if (event.which === 13 || event.keyCode === 13) {
          routeNavigation(event);
        }
      };

      var handleOnClick = function handleOnClick(event) {
        routeNavigation(event);
      };

      var Component = function Component() {
        return /*#__PURE__*/React.createElement("button", {
          "data-testid": 'cms-navigation-button',
          onClick: handleOnClick,
          onKeyDown: handleKeyDown,
          className: styles.linkButton,
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize("".concat(domNode.innerHTML, "\n            ").concat(dataLinkType === 'external' ? '<span class="visuallyHidden">' + getString('global.opensDialog') + '</span>' : ''))
          }
        });
      }; // if visualCta is true, then wrap the button around the children


      var ComponentVisualCta = function ComponentVisualCta() {
        return /*#__PURE__*/React.createElement("button", {
          "data-testid": 'cms-navigation-button',
          onClick: handleOnClick,
          onKeyDown: handleKeyDown,
          className: styles.linkButton
        }, React.Children.map(children, function (child) {
          return child;
        }));
      };

      return children ? ComponentVisualCta : Component;
    });

    _defineProperty(this, "getPhoneNumber", function (_ref4) {
      var device = _ref4.device;
      // Note: Some phone numbers are wrapped by two spans
      var wrappedNumber = _this.domNode.textContent;
      var numberNoDashes = wrappedNumber ? wrappedNumber.replace(/-/g, '') : '';
      var Component = device.isMobile() ? function () {
        return /*#__PURE__*/React.createElement("a", {
          className: "phoneNumber",
          href: "tel:+".concat(numberNoDashes)
        }, wrappedNumber);
      } : function () {
        return wrappedNumber;
      };
      return Component;
    });

    _defineProperty(this, "gettersByNodeName", {
      'A': this.getLink,
      'SUP': this.getFootnote
    });

    _defineProperty(this, "gettersByNodeClass", {
      'c12': this.getPhoneNumber
    });

    this.domNode = _domNode;
    this.children = _children;
  }

  _createClass(ComponentByNode, [{
    key: "get",
    value: function get(device, openModal, setModalNavigationDetails, getString, references, footnotes, templateType) {
      var domNode = this.domNode,
          gettersByNodeName = this.gettersByNodeName,
          gettersByNodeClass = this.gettersByNodeClass;
      var getComponent = gettersByNodeName[domNode.nodeName];
      if (getComponent) return getComponent({
        openModal: openModal,
        setModalNavigationDetails: setModalNavigationDetails,
        getString: getString,
        references: references,
        footnotes: footnotes,
        templateType: templateType
      }); //also get by css class. Although this is looping through for flagged css classes, it will only return the first css-matching component

      var cssClasses = domNode && domNode.classList;

      if (cssClasses) {
        for (var i = 0; i < cssClasses.length; i++) {
          getComponent = gettersByNodeClass[cssClasses[i]];
          if (getComponent) return getComponent({
            device: device
          });
        }
      }

      return null;
    }
  }]);

  return ComponentByNode;
}();

export default ComponentByNode;